export default {
  baseStyle: {
    control: {
      borderWidth: '2px',
      borderRadius: '4px',
      borderColor: 'blueGrey.800',
      _checked: {
        bg: 'orange.500',
        borderColor: 'orange.500',
        _hover: {
          bg: 'orange.700',
          borderColor: 'orange.700',
        },
      },
    },
    label: {},
  },
  sizes: {
    lg: {
      control: { w: '20px', h: '20px' },
      label: { fontSize: '16px' },
    },
  },
};
